/**
 * Syncs document title + meta description for every route tree (public and
 * private). Mounted once under PageMetaProvider inside the router.
 */

import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useInboxStore } from '../stores/inboxStore';

export function DocumentTitleSync(): null {
  const inboxUnread = useInboxStore((s) => s.unread);
  useDocumentTitle(inboxUnread);
  return null;
}
